import { useEffect, useState } from 'react';

import Button from '../Button/Button';
import { CounterInputStyled, CounterWrapperStyled } from './Counter.styled';

type CounterPropsT = {
  value?: number;
  name?: string;
  min?: number;
  max?: number;
  isInputDisabled?: boolean;
  onChange: (val: number) => void;
};

const Counter: React.FC<CounterPropsT> = ({
  value,
  name,
  min = 1,
  max,
  isInputDisabled = false,
  onChange,
}) => {
  const [currentValue, setValue] = useState(value || min);

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const ONLY_NUMBERS = /^[0-9\b]+$/;

    if (e.target.value === '' || ONLY_NUMBERS.test(e.target.value)) {
      if (max && +e.target.value <= max) {
        handleOnChange(Number(e.target.value));
      }
    }
  };

  const handleBlur = () => {
    if (currentValue <= min) {
      handleOnChange(min);
    }

    if (max && currentValue >= max) {
      handleOnChange(max);
    }
  };

  const handleOnChange = (val: number) => {
    setValue(val);
    onChange(val);
  };

  useEffect(() => {
    if (value !== currentValue) {
      handleOnChange(Number(value));
    }
  }, [value]);

  return (
    <CounterWrapperStyled>
      <Button
        modifier="counter"
        onClick={() => handleOnChange(currentValue - 1)}
        disabled={currentValue <= min}
      >
        -
      </Button>
      <CounterInputStyled
        type="text"
        name={name}
        onChange={handleChangeInput}
        value={currentValue}
        disabled={isInputDisabled}
        onBlur={handleBlur}
      />
      <Button
        modifier="counter"
        onClick={() => handleOnChange(currentValue + 1)}
        disabled={!!max && currentValue >= max}
      >
        +
      </Button>
    </CounterWrapperStyled>
  );
};

export default Counter;
